<template>
  <div>
    <div class="row" style="padding: 1%">
      <div class="col-lg-12">
        <h4 class="info-text">BAHAGIAN A - Maklumat Pegawai Penyiasat</h4>
        <div class="row justify-content-center">
          <div class="col-sm-12">
            <div class="row">
              <div class="col-md-2" style="border-right: solid red 1px">
                <base-input
                  @change="checknokawalan()"
                  label="No Kawalan Kes"
                  v-model="noKes"
                  :disabled="staff"
                ></base-input>
              </div>
              <div class="col-md-4">
                <base-input label="Nama" v-model="nama"></base-input>
              </div>
              <div class="col-md-2">
                <base-input
                  label="No Staf"
                  @change="check()"
                  v-model="noStaff"
                ></base-input>
              </div>
              <div class="col-md-3">
                <base-input
                  label="Service Area / Jabatan"
                  v-model="jabatan"
                ></base-input>
              </div>
              <div class="col-sm-1" style="padding-top: 1.5%">
                <base-button
                  @click="addNewInvestigator()"
                  round
                  icon
                  type="green"
                  :disabled="blockadd"
                >
                  <i class="tim-icons icon-simple-add"></i>
                </base-button>
              </div>
            </div>
          </div>
        </div>
        <hr style="margin-top: 1%" />
        <h4 class="info-text">List of Investigator</h4>
        <div class="row justify-content-center mt-5">
          <div class="col-sm-8">
            <el-table
              :data="tableInvestigator"
              style="border: solid white; border-radius: 10px"
              :header-cell-style="{
                background: 'transparent',
                border: 'none',
                borderBottom: '0.5px solid #3d3f51',
              }"
              :cell-style="{
                border: 'none',
                borderBottom: '0.5px solid #3d3f51',
              }"
            >
              <el-table-column
                min-width="100"
                sortable
                align="center"
                label="Investigator Name"
                property="InstName"
              ></el-table-column>
              <el-table-column
                min-width="100"
                sortable
                align="center"
                label="No Staff"
                property="InstStaffID"
              ></el-table-column>
              <el-table-column
                min-width="100"
                sortable
                align="center"
                label="Service Area/Jabatan"
                property="InstDept"
              ></el-table-column>
              <el-table-column :min-width="50" align="right" label="Actions">
                <div slot-scope="props">
                  <el-tooltip
                    content="Delete"
                    placement="bottom"
                    effect="light"
                  >
                    <base-button
                      @click.native="handleDelete(props.$index, props.row)"
                      class="remove btn-link"
                      type="danger"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-simple-remove"></i>
                    </base-button>
                  </el-tooltip>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Option, Select, DatePicker } from "element-ui";
import swal from "sweetalert2";
import ReportImage from "../ReportImage";

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
  },
  data() {
    return {
      tableInvestigator: [],
      noKes: "",
      nama: "",
      noStaff: "",
      jabatan: "",
      blockadd: false,
      staff: false,
      caseno: [],
    };
  },
  mounted() {
    this.callnokes();
  },
  methods: {
    callnokes() {
      this.$http
        .get(":9994/api/v1/incident/associateInvestigator")
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            let temp = [];
            for (var i = 0; i < response.length; i++) {
              if (temp.indexOf(response[i].ControlCaseNO) === -1) {
                temp.push(response[i].ControlCaseNO);
              }
            }
            for (var i = 0; i < temp.length; i++) {
              this.caseno.push(temp[i]);
            }
          }
        });
    },
    check() {
      console.log(this.tableInvestigator);
      for (var i = 0; i < this.tableInvestigator.length; i++) {
        console.log("masuk");
        if (this.noStaff === this.tableInvestigator[i].InstStaffID) {
          swal({
            text: `Staff id ` + this.noStaff + ` already exist!`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
          this.blockadd = true;
        } else {
          this.blockadd = false;
        }
      }
      if (this.tableInvestigator.length == 0) {
        this.blockadd = false;
      }
    },
    checknokawalan() {
      console.log("check here");
      console.log(this.caseno);
      console.log(this.noKes);
      this.blockadd = true;
      for (var i = 0; i < this.caseno.length; i++) {
        if (this.noKes == this.caseno[i]) {
          console.log("sama");
          swal({
            text: `Case no ` + this.noKes + ` already exist!`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
          this.blockadd = true;
        } else {
          this.blockadd = false;
        }
      }
      if (this.caseno.length == 0) {
        this.blockadd = false;
      }
    },
    addNewInvestigator() {
      let obje = {
        CaseNO: this.noKes,
        InstName: this.nama,
        InstStaffID: this.noStaff,
        InstDept: this.jabatan,
      };
      console.log(obje);
      this.tableInvestigator.push(obje);
      console.log(this.tableInvestigator);
      this.nama = "";
      this.noStaff = "";
      this.jabatan = "";
      this.staff = true;
      // this.passInvestigator(this.tableInvestigator)
    },
    // passInvestigator(investigator){
    //   // this.$root.$emit('investigatordetail', investigator)
    // },
    handleDelete(index, row) {
      console.log(row);
      console.log(index);
      let indexToDelete = this.tableInvestigator.findIndex(
        (tableRow) => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableInvestigator.splice(indexToDelete, 1);
      }

      this.staff = false;
      // this.tableInvestigator.splice(row.noStaff,1)
      // console.log(this.tableInvestigator)

      // if(this.tableInvestigator.length = 0){
      //   this.staff = false
      // }
      // swal({
      //   title: "Are you sure?",
      //   text: `You won't be able to revert this!`,
      //   type: "warning",
      //   showCancelButton: true,
      //   confirmButtonClass: "btn btn-success btn-fill",
      //   cancelButtonClass: "btn btn-danger btn-fill",
      //   confirmButtonText: "Yes, delete it!",
      //   buttonsStyling: false
      // }).then(result => {
      //   if (result.value) {
      // this.deleteRow(index,row);
      // swal({
      //   title: "Deleted!",
      //   text: `You deleted ${row.InstName}`,
      //   type: "success",
      //   confirmButtonClass: "btn btn-success btn-fill",
      //   buttonsStyling: false
      // });
      //   }
      // });
    },
    // deleteRow(index,row) {
    // var id = 88;

    // for(var i = 0; i < this.tableInvestigator.length; i++) {
    //     if(this.tableInvestigator[i].InstStaffID == row.InstStaffID) {
    //         this.tableInvestigator.splice(i, 1);
    //         break;
    //     }
    // }
    // console.log(index)
    // console.log(row)
    // for(var i=0; i<this.tableInvestigator.length; i++){
    //   console.log(this.tableInvestigator[i])
    // }
    // // console.log(this.tableInvestigator)
    // // let indexToDelete = this.tableInvestigator.findIndex(
    // //   tableRow => tableRow.noStaff === row.noStaff
    // // );
    // // if (indexToDelete >= 0) {
    //   this.tableInvestigator.slice(index, 1)
    // }
    // this.tableInvestigatorhero.filter(item => item.noStaff !== 1);

    // enable no staff column if table empty
    //   if(this.tableInvestigator.length = 0){
    //     this.staff = false
    //   }
    // },
    onFileChange(file) {
      this.file = file;
    },
    validate() {
      let investigator = this.tableInvestigator;
      if (this.tableInvestigator.length === 0) {
        swal({
          title: "investigator field is required!",
          // text: `You deleted ${row.InstName}`,
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          buttonsStyling: false,
        });
      } else {
        this.$root.$emit("investigatordetail", investigator);
        return Promise.resolve(true);
      }
    },
  },
};
</script>
<style scoped>
textarea {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
.address {
  width: 100%;
  height: 100px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
.huraian {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
</style>
